import { render, staticRenderFns } from "./AuthResetPasswordChangePassword.vue?vue&type=template&id=79228441&"
import script from "./AuthResetPasswordChangePassword.vue?vue&type=script&lang=js&"
export * from "./AuthResetPasswordChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports